import React from 'react';
import { TimelineDropSlot, TimelineDropSlotKinds } from 'shared/types/timeline';

import * as Styled from './sidebar-drop-indicator.style';

export type SidebarDropIndicatorProps = {
  slot: TimelineDropSlot;
};

export const SidebarDropIndicator: React.FC<SidebarDropIndicatorProps> = ({
  slot,
}) => {
  if (slot.kind === TimelineDropSlotKinds.Nest) {
    return (
      <Styled.NestHighlight
        $depth={slot.depth}
        style={{ top: `${slot.top}px` }}
      />
    );
  }

  return <Styled.Line $depth={slot.depth} style={{ top: `${slot.top}px` }} />;
};
